export const productCardTransportConverterMobile = (item)=>{
    const { link ={
        href: ''
    } , image ={
        src: '',
        alt: '',
        alternative: '',
        text: '',
        title: ''
    } , title ='' , price ={} , textInfo , descriptions =[] , isBlackfriday =false  } = item;
    return {
        config: {
            isBlackfriday,
            literals: {
                fromCaption: item.price?.from
            }
        },
        link,
        image,
        title,
        subtitle: item.subtitle,
        textInfo,
        descriptions,
        price: {
            value: price?.value ? Math.floor(price?.value) : undefined,
            from: !!price?.from
        }
    };
};

//# sourceMappingURL=index.js.map